// extracted by mini-css-extract-plugin
export default {"relogioNumero":"relogio_relogioNumero__nuyQ1","relogioDivisao":"relogio_relogioDivisao__XWGug"};